<template>
  <StakeTooltip
    position="left"
    :label="copied ? 'Copied!' : 'Copy value to clipboard'"
  >
    <Button
      @click.stop="copyToClipboard(value)"
      class="copy-button"
      :class="{ 'is-copied': copied }"
      variant="ghost"
      :icon-only="copyIcon"
    />
  </StakeTooltip>
</template>

<script setup>
import { computed, ref } from "vue";
import Button from "../button/Button.vue";
import StakeTooltip from "../../StakeTooltip.vue";

defineProps({
  value: {
    type: [String, Number, Boolean],
    required: false,
    default: "",
  },
});

const copied = ref(false);

const copyIcon = computed(() =>
  copied.value ? "fas fa-check" : "fas fa-clipboard"
);

const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    copied.value = true;
    setTimeout(() => (copied.value = false), 1000);
  } catch (err) {
    console.error("Failed to copy:", err);
  }
};
</script>

<style scoped>
.copy-button {
  color: var(--stk-primary);
  padding: 0;

  &.is-copied {
    color: var(--stk-success-50);
  }
}
</style>
